import { connect } from "react-redux";
// import { requestAdminAmcs } from "src/redux/actions";
import GeneratedLink from "./generated-link";

const mapStateToProps = (state) => ({
  createdGenericLink: state.adminGenericLinks?.createdGenericLink,
});

export default connect(mapStateToProps, {})(GeneratedLink);
